const config = [
  //* ——— Users ——————————————————
  {
    path: '/config/users',
    name: 'config-users',
    component: () => import('@/views/system/config/users/UsersList.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/data/view',
    name: 'data-view',
    component: () => import('@/views/data/DataView.vue'),
    meta: {
      layout: 'content',
    },
  },
]

export default config
